const log = require('log').create('canonicalUrl') // eslint-disable-line

/**
 * canonicalDomain - returns user's conanical domain, or their first domain, or undefined
 *
 * @param  {JSON} user JSON user object
 */
module.exports = function canonicalDomain(user) {
    const domains = user && user.mapped_domains || []

    // if there's a canonical domain...
    const canonical_domains = domains.filter(domain => domain.canonical)

    // return the first canonical domain, or the first domain, or undefined
    return canonical_domains[0] || domains[0]
}
